import React, { useEffect } from 'react';
import {
  subscribeStorageConsent,
} from '../privacy/storageConsent';
import { ensureToltLoaded, revokeToltClient } from '../services/toltAffiliate';

const ToltConsentLoader: React.FC = () => {
  useEffect(() => {
    return subscribeStorageConsent((consent) => {
      if (consent?.marketing === true) {
        void ensureToltLoaded();
      } else {
        revokeToltClient(true);
      }
    });
  }, []);

  return null;
};

export default ToltConsentLoader;
